import { Favicon } from 'components/misc';
import React, { Component } from 'react';
import { Provider } from 'react-redux';
import configureStore from 'redux/configureStore';
import ScreensRoot from 'screens/Root';

const store = configureStore();

class App extends Component {
  render() {
    return (
      <Provider store={store}>
        <Favicon />

        <ScreensRoot />
      </Provider>
    );
  }
}

export default App;
